import { ReportTypeItem, EnumReportOnlineCheckListItem } from 'src/admin/core/services/financial-flows'
import { formatJSDateToLocal } from 'src/admin/core/services/dateFunctions'
import { Agency } from 'src/core/models'
import { ProductOnlineCheckOption } from 'src/admin/core/components/Select/ProductOnlineCheckSelect'
import { LocationLineCheckOption } from 'src/admin/core/components/Select/LocationLineCheckSelect'

/**
 * Filter model for financial flows
 */
export interface FilterModel {
  product: string
  agencyId: string
  from: string
  to: string
  currency: string
  productObj?: ProductOnlineCheckOption
  agencyObj?: Agency
  locationLineObj?: LocationLineCheckOption
  // Text filter fields for dynamic filtering
  agencyFilterText: string
  productFilterText: string
}

const today = new Date()

export const initialFilters: FilterModel = {
  product: '',
  agencyId: '',
  from: formatJSDateToLocal(today) + 'T00:00:00Z',
  to: formatJSDateToLocal(today) + 'T23:59:59Z',
  currency: 'DOP',
  productObj: undefined,
  agencyObj: undefined,
  locationLineObj: undefined,
  agencyFilterText: '',
  productFilterText: '',
}

/**
 * State interface for the Financial Flows context
 * Extensible to add more data types in the future
 */
export interface FinancialFlowsState {
  // Report Types
  reportTypes: ReportTypeItem[]
  selectedReportType: ReportTypeItem | null
  reportTypesLoading: boolean
  reportTypesError: string | null
  // Filters
  filters: FilterModel
  filtersLoading: boolean
  // Report Data (search results)
  reportData: EnumReportOnlineCheckListItem[]
  reportDataLoading: boolean
  reportDataError: string | null
}

/**
 * Actions interface for the Financial Flows context
 */
export interface FinancialFlowsActions {
  // Report Types actions
  setReportTypes: (reportTypes: ReportTypeItem[]) => void
  setSelectedReportType: (reportType: ReportTypeItem | null) => void
  setReportTypesLoading: (loading: boolean) => void
  setReportTypesError: (error: string | null) => void
  loadReportTypes: () => Promise<void>
  // Filter actions
  setFilters: (filters: FilterModel) => void
  setFiltersLoading: (loading: boolean) => void
  // Report Data actions
  setReportData: (data: EnumReportOnlineCheckListItem[]) => void
  setReportDataLoading: (loading: boolean) => void
  setReportDataError: (error: string | null) => void
  searchReportData: () => Promise<void>
}

/**
 * Combined context type
 */
export interface FinancialFlowsContextType extends FinancialFlowsState, FinancialFlowsActions {}

/**
 * Initial state for the context
 */
export const initialFinancialFlowsState: FinancialFlowsState = {
  reportTypes: [],
  selectedReportType: null,
  reportTypesLoading: false,
  reportTypesError: null,
  filters: initialFilters,
  filtersLoading: false,
  // Report Data initial state
  reportData: [],
  reportDataLoading: false,
  reportDataError: null,
}

